/**
 * Type of cards containing graphics and data
 */
export enum DeviceState {
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    CONNECTED = 'CONNECTED',
    LOST_CONNECTION = 'LOST_CONNECTION',
}
